import type { insuranceCoverageApiSpec } from "@wingspanhq/wingspan-api-types";
import { IInsuranceCoverageListRequestFilter } from "./types";
import { insuranceCoverageService } from "./service";
import { ListRequestQuery } from "../../../../utils/serviceHelper";

type IInsuranceCoverage = insuranceCoverageApiSpec.InsuranceCoverage;
type IInsuranceCoverageListRequestSort = NonNullable<
  insuranceCoverageApiSpec.operations["listInsuranceCoverages"]["parameters"]["query"]
>["sort"];

export const getInsuranceCoverages = async (
  query?: ListRequestQuery<
    IInsuranceCoverageListRequestFilter,
    IInsuranceCoverageListRequestSort
  >
): Promise<IInsuranceCoverage[]> => {
  const { data } = await insuranceCoverageService.get<IInsuranceCoverage[]>(
    `/`,
    {
      params: query
    }
  );

  return data;
};
